import inlineFindTool from './inlineFindTool'
export default inlineFindTool